export default __webpack_public_path__ + "static/media/clinic9.b487da04.jpg";